import { get } from 'lodash';

var ACCOUNT_PROPERTIES_ACCESSOR = 'accountContactRole';

export default (function (roleType, roleModel, accountRoleName, policyRoleName) {
    var hasPolicyDetails = roleType !== 'account';
    var accountContactRole = hasPolicyDetails ? get(roleModel, ACCOUNT_PROPERTIES_ACCESSOR) : roleModel;
    var accountRoleDetails = get(accountContactRole, accountRoleName);
    var policyRoleDetails = get(roleModel, policyRoleName);
    var fieldGetter = function fieldGetter(accountRoleField, policyRoleField) {
        var retValue = get(accountRoleDetails, accountRoleField);
        if (hasPolicyDetails && policyRoleField) {
            retValue = get(policyRoleDetails, policyRoleField) || retValue;
        }
        return retValue;
    };

    return {
        fieldGetter: fieldGetter,
        fieldValueGetter: function fieldValueGetter(accountRoleField, policyRoleField) {
            var vmNode = fieldGetter(accountRoleField, policyRoleField);
            return vmNode && vmNode.value;
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/roles/getRoleProperty.js
// module id = 58
// module chunks = 0